module.exports = __webpack_public_path__ + "img/kensekai_karateschule.29bcae53.png";